import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core'
import { SafeResourceUrl } from '@angular/platform-browser'

import { ParentToChildMessage } from '../../utils/shell-bridge'

/**
 * The iframe itself: sizing, loading state and the transport to the hosted app.
 * All routing and protocol decisions live in ReactAppComponent.
 */
@Component({
  selector: 'app-react-frame',
  templateUrl: './react-frame.component.html',
  styleUrls: ['./react-frame.component.styl']
})
export class ReactFrameComponent implements OnChanges {
  @Input() public src!: SafeResourceUrl
  @Input() public title: string = 'Aplicación'

  public isLoading: boolean = true

  @ViewChild('frame') private frame!: ElementRef

  public ngOnChanges (): void {
    // A new src means a brand new document load: show the loading state again.
    this.isLoading = true
  }

  public onLoad (): void {
    this.isLoading = false
  }

  /** Window of the hosted app, used by the shell to validate message senders. */
  public get contentWindow (): Window | null {
    const frame = this.frameElement()
    return frame ? frame.contentWindow : null
  }

  public postMessage (message: ParentToChildMessage): void {
    const childWindow = this.contentWindow
    if (!childWindow) {
      return
    }
    childWindow.postMessage(message, window.location.origin)
  }

  private frameElement (): HTMLIFrameElement | null {
    return this.frame ? this.frame.nativeElement as HTMLIFrameElement : null
  }
}
